/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_SCREENSHOT_DETAILS_REQUEST,
  FETCH_SCREENSHOT_DETAILS_SUCCESS,
  FETCH_SCREENSHOT_DETAILS_FAILURE,
  FETCH_DELETE_SCREENSHOT_REQUEST,
  FETCH_DELETE_SCREENSHOT_SUCCESS,
  FETCH_DELETE_SCREENSHOT_FAILURE,
} from "./ScreenshotsUploadTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchScreenshotDetailsRequest = () => {
  return {
    type: FETCH_SCREENSHOT_DETAILS_REQUEST,
  };
};

export const fetchScreenshotDetailsSuccess=(screenshot)=>{
  return {
    type:FETCH_SCREENSHOT_DETAILS_SUCCESS,
    payload:screenshot
  }
}

  export const fetchDeleteScreenShotRequest=()=>{
    return{
      type:FETCH_DELETE_SCREENSHOT_REQUEST
    }
  }

  export const fetchDeleteScreenShotSuccess=()=>{
    return{
      type:FETCH_DELETE_SCREENSHOT_SUCCESS
    }
  }

  export const fetchDeleteScreenShotFailed=(error)=>{
    return{
      type:FETCH_DELETE_SCREENSHOT_FAILURE,
      payload:error
    }
  }
  

export const fetchScreenshotDetailsFailure = (error) => {
  return {
    type: FETCH_SCREENSHOT_DETAILS_FAILURE,
    payload: error,
  };
};


export const fetchScreenshotDetails = (
  applicationId,
  submissionId,
  defaultLanguage,
  image
) => {
  return async function (dispatch) {
    dispatch(fetchScreenshotDetailsRequest());
    try {
      const data = await APIManager.uploadScreenShotDetails(
        applicationId,
        submissionId,
        defaultLanguage,
        image
      );
      dispatch(fetchScreenshotDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchScreenshotDetailsFailure(error));
      dispatch(commonError(error, FETCH_SCREENSHOT_DETAILS_FAILURE));
    }
  };
};
export const fetchDeleteScreenShot = (
  applicationId,
  submissionId,
  screenshotId,
  defaultLanguage
) => {
  return async function (dispatch) {
    dispatch(fetchDeleteScreenShotRequest());
    try {
      await APIManager.deleteScreenShots(
        applicationId,
        submissionId,
        screenshotId,
        defaultLanguage
      );
      dispatch(fetchDeleteScreenShotSuccess());
    } catch (error) {
      dispatch(fetchDeleteScreenShotFailed(error));
      dispatch(commonError(error, FETCH_DELETE_SCREENSHOT_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
